import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import NoData from "../../../components/NoDataFound/NoData";
import { getCertificateListRequest, getLifetimeCertificateListRequest } from "../../../utils/apis/account";
import "./style.scss";
import LoaderOverlay from "../../../reusableComponents/Loader";
import { Skeleton } from "antd";
import Tabination from "../../../reusableComponents/Tabination";

const AllCertificates = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const idToken = useSelector((state) => state.auth.idToken);
  const [certificateList, setCertificateList] = useState([]);
  const [lifetimeCertificateList, setLifetimeCertificateList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const selectedBrand = useSelector((state) => state.brand.selectedBrand);

  const [challengeCertificates, setChallengeCertificates] = useState([]);
  const [fundedCertificates, setFundedCertificates] = useState([]);
  const [payoutCertificates, setPayoutCertificates] = useState([]);

  const sortByDate = (certificates) => {
    return [...certificates].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
  };

  const categorizeCertificates = (certificates) => {
    const challenges = [];
    const funded = [];
    const payouts = [];

    certificates.forEach((cert) => {
      if (cert.type === "Profit Split") {
        payouts.push(cert);
      } else if (cert.type === "Funded") {
        funded.push(cert);
      } else if (cert.type === "1 Step Pass" || cert.type === "2 Step Pass") {
        challenges.push(cert);
      }
    });

    setChallengeCertificates(sortByDate(challenges));
    setFundedCertificates(sortByDate(funded));
    setPayoutCertificates(sortByDate(payouts));
  };

  const fetchCertificates = async () => {
    setIsLoading(true);
    try {
      const response = await getCertificateListRequest(idToken, selectedBrand);
      setCertificateList(response);
      categorizeCertificates(response);
    } catch (error) {
      console.error(error);
    }
    try {
      const lifetimeResponse = await getLifetimeCertificateListRequest(idToken, selectedBrand);
      setLifetimeCertificateList(lifetimeResponse?.file_url ? [lifetimeResponse] : []);
    } catch (error) {
      console.error(error);
    }
    setIsLoading(false);
  };
  useEffect(() => {
    fetchCertificates();
  }, [idToken]);

  function splitTitle(title) {
    const parts = title.split(" - ");
    return {
      id: parts[0]?.trim() || "",
      name: parts[1]?.trim() || "",
      type: parts[2]?.trim() || "",
    };
  }
  useEffect(() => {
    if (isLoading) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isLoading]);

  const [loadedImages, setLoadedImages] = useState({});

  const handleImageLoad = (idx, category) => {
    setLoadedImages((prev) => ({ ...prev, [`${category}-${idx}`]: true }));
  };

  const renderCertificateCard = (item, idx, category) => {
    const imageKey = `${category}-${idx}`;
    return (
      <div className="certificate-cards" key={idx}>
        <div className="inner-card" onClick={() => setOpenModal(true)}>
          <div className="certificate-img">
            {!loadedImages[imageKey] && (
              <div className="skeleton-wrapper">
                <Skeleton.Image active={true} />
              </div>
            )}
            <img
              src={category === "lifetime" ? item.file_url : item.file}
              alt="certificate card"
              className="card-img"
              style={{ display: loadedImages[imageKey] ? "block" : "none" }}
              onLoad={() => handleImageLoad(idx, category)}
              onError={() => handleImageLoad(idx, category)}
            />
          </div>
          <div className="cert-card-info">
            {category === "lifetime" ? (
              <>
                <div className="cert-card-wrapper">
                  <h2 className="card-title">Payout count</h2>
                  <h2 className="card-title">Total amount</h2>
                </div>
                <div className="cert-card-wrapper">
                  <h2 className="card-title">{item.payout_count}</h2>
                  <h2 className="card-title">${item.total_amount ? parseFloat(item.total_amount).toFixed(2) : "0.00"}</h2>
                </div>
              </>
            ) : (
              <>
                <div className="cert-card-wrapper">
                  <h2 className="card-title">{splitTitle(item.title).name}</h2>
                  <h2 className="card-title">{splitTitle(item.title).type}</h2>
                </div>
                <div className="cert-card-wrapper">
                  <h2 className="card-title">{splitTitle(item.title).id}</h2>
                  <h2 className="date">{item.created_at}</h2>
                </div>
              </>
            )}
          </div>
          <div className="card-download" onClick={(e) => e.stopPropagation()} style={{ cursor: "pointer" }}>
            <a href={category === "lifetime" ? item.file_url : item.file} target="_blank" rel="noreferrer">
              <button>Download</button>
            </a>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {isLoading && <LoaderOverlay />}
      <Tabination
        variant={8}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        tabItems={[
          {
            name: "Payout Certificates",
            content: (
              <>
                {payoutCertificates.length <= 0 && (
                  <div className="certificate-no-data">
                    <NoData msg={"No certificates found"} />
                  </div>
                )}
                <div className="main_certificates">
                  {payoutCertificates.map((item, idx) => renderCertificateCard(item, idx, "payout"))}
                </div>
              </>
            ),
          },
          {
            name: "Challenge Certificates",
            content: (
              <>
                {challengeCertificates.length <= 0 && (
                  <div className="certificate-no-data">
                    <NoData msg={"No certificates found"} />
                  </div>
                )}
                <div className="main_certificates">
                  {challengeCertificates.map((item, idx) => renderCertificateCard(item, idx, "challenge"))}
                </div>
              </>
            ),
          },
          {
            name: "Funded Certificates",
            content: (
              <>
                {fundedCertificates.length <= 0 && (
                  <div className="certificate-no-data">
                    <NoData msg={"No certificates found"} />
                  </div>
                )}
                <div className="main_certificates">
                  {fundedCertificates.map((item, idx) => renderCertificateCard(item, idx, "funded"))}
                </div>
              </>
            ),
          },
          {
            name: "Lifetime Payout Certificates",
            content: (
              <>
                {(!Array.isArray(lifetimeCertificateList) || lifetimeCertificateList.length <= 0) && (
                  <div className="certificate-no-data">
                    <NoData msg={"No certificates found"} />
                  </div>
                )}
                <div className="main_certificates">
                  {Array.isArray(lifetimeCertificateList) && lifetimeCertificateList.map((item, idx) => renderCertificateCard(item, idx, "lifetime"))}
                </div>
              </>
            ),
          },
        ]}
      />
    </>
  );
};

export default AllCertificates;
